import ShowValidField from './ShowValidField';
import ShowInvalidField from './ShowInvalidField';

export const FormValidator = (formId, Rules) => {
    let res = true;
    const form = document.getElementById(formId);
    let inputs = form.querySelectorAll("input,select,textarea");

    for (let i=0; i<inputs.length; i++) {
       
        if (window.getComputedStyle(inputs[i])==='hidden'){
            continue;
        }
        let value;
        
        if (inputs[i].getAttribute('type')=='checkbox') {
           if (inputs[i].checked) {
               value = inputs[i].value;
           }
        } else {
            value = inputs[i].value;
        }
        let id = inputs[i].getAttribute('id');

        let validationResponse;
       
        if (Rules[id]){
            if (typeof Rules[id] == 'object') {
                validationResponse = Rules[id].rule(value, Rules[id].param);
            } else {
                validationResponse = Rules[id](value);
            }
            
            ShowValidation(id, validationResponse); 
            if (!validationResponse.status) {
                res = false;
            };
        }
       
    }
    
    return res;
}

export const ShowValidation = (id, response) => {
    if (response.status==false) {
        ShowInvalidField(id, response.msg);
    }
    else {
        ShowValidField(id, response.msg);
    }
}

export const ResetValidation = (formId) => {
    const form = document.getElementById(formId);
    let inputs = form.querySelectorAll("input,select");
    for (let i=0; i<inputs.length; i++) {
        inputs[i].classList.remove('is-valid');
    }
}

export const ScrollToError = (formId) => {
    const form = document.getElementById(formId);
    let invalidField = form.getElementsByClassName('is-invalid');
    if (invalidField.length> 0) {
        invalidField[0].parentNode.scrollIntoView({behavior: "smooth"});
    }
}

export const FormChecker = (formId, Rules) => { 
    let res = true;
    var validationResult = {};
    
    const form = document.getElementById(formId);
    let inputs = form.querySelectorAll("input,select,textarea");

    for (let i=0; i<inputs.length; i++) {
       
        if (window.getComputedStyle(inputs[i])==='hidden'){
            continue;
        }
        let value;
        let id = inputs[i].getAttribute('id');
        let inputType = inputs[i].getAttribute('type');
        if (inputType=='checkbox') {
           if (inputs[i].checked) {
               value = inputs[i].value;
           } else {
               value = null;
           }
        } else if (inputType=='radio'){
            if (inputs[i].checked) {
                value = inputs[i].value;
            }
            id = inputs[i].getAttribute('name');
        }
        else {
            value = inputs[i].value;
        }
        
        let validationResponse;
       
        if (Rules[id]){
            if (typeof Rules[id] == 'object') {
                validationResponse = Rules[id].rule(value, Rules[id].param);
            } else {
                validationResponse = Rules[id](value);
            }
            
            if (inputType == 'radio' && validationResult.hasOwnProperty(id) && validationResult[id].field == 'is-invalid' && !value) {
                continue;
            } else {
                validationResult[id] = {
                    help: validationResponse.status ? 'valid-feeback' : 'invalid-feedback',
                    field: validationResponse.status ? 'is-valid' : 'is-invalid',
                    error: validationResponse.msg
                };
            }
          
            if (!validationResponse.status) {
                res = false;
            };
        }
    }
    
    return {status: res, data: validationResult};
}




